import React from 'react';
export function StatsBar() {
  const stats = ['Millions of emails analyzed', 'Significant open rate improvements', 'Brands optimized globally', 'Proven revenue impact'];
  return <div className="bg-gray-900 py-4 overflow-hidden" data-id="element-279">
      <div className="relative flex overflow-x-hidden" data-id="element-280">
        <div className="animate-marquee whitespace-nowrap flex space-x-12 px-4" data-id="element-281">
          {/* Duplicate for infinite scroll effect */}
          {[...stats, ...stats, ...stats].map((stat, index) => <div key={index} className="flex items-center space-x-2 text-gray-100 font-medium" data-id="element-282">
              <span className="h-1.5 w-1.5 rounded-full bg-success" data-id="element-283"></span>
              <span data-id="element-284">{stat}</span>
            </div>)}
        </div>
      </div>
    </div>;
}